// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { Passenger } from './Passenger';
/* END-USER-IMPORTS */

export default class WaitingPassenger extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // taxiSign
    const taxiSign = scene.add.image(-38.5, 0, "game", "taxi-sign.png");
    taxiSign.setOrigin(0.5, 1);
    this.add(taxiSign);

    // passenger
    const passenger = scene.add.image(38.5, 0, "game-32", "passenger-1.png");
    passenger.setOrigin(0.5, 1);
    this.add(passenger);

    // icon
    const icon = scene.add.image(40, -183, "game-32", "icon-passenger-1.png");
    icon.scaleX = 0.25;
    icon.scaleY = 0.25;
    this.add(icon);

    this.taxiSign = taxiSign;
    this.passenger = passenger;
    this.icon = icon;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private taxiSign: Phaser.GameObjects.Image;
  private passenger: Phaser.GameObjects.Image;
  private icon: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  get IconY() {
    return this.y + this.icon.y;
  }

  public init(passenger: Passenger) {
    this.passenger.setFrame(passenger.Sprite);
    this.icon.setFrame(passenger.Icon);

     this.scene.add.tween({
       targets: this.icon,
       scaleX: 0.35,
       scaleY: 0.35,
       duration: 400,
       ease: Phaser.Math.Easing.Cubic.InOut,
       yoyo: true,
       repeat: -1
     });

    this.scene.add.tween({
         targets: this.passenger,
         scaleX: 1.0,
         scaleY: 1.05,
       //  y: this.passenger.y-15,
         duration: 300,
         ease: Phaser.Math.Easing.Cubic.InOut,
         yoyo: true,
         repeat: -1
       });

       this.scene.add.tween({
        targets: this.taxiSign,
        scaleX: 1.1,
        scaleY: 1.2,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.InOut,
        yoyo: true,
        repeat: -1
      });
  }

  public pickup() {
    this.icon.alpha = 0;
    this.scene.tweens.killTweensOf(this.icon);
    this.scene.tweens.killTweensOf(this.taxiSign);
    this.scene.tweens.killTweensOf(this.passenger);

    this.scene.add.tween({
      targets: this.taxiSign,
      scaleX: 1,
      scaleY: 1,
      duration: 300,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.scene.add.tween({
      targets: this.passenger,
      alpha: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.scene.time.delayedCall(10000, () => {
          this.destroy();
        });
      }
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
